import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { onSessionExpired, SESSION_EXPIRED_KEY } from '@/api/mutator/sessionExpired';
import { ROUTE } from '@/constants/route';
import { useAuth } from '@/hooks/useAuth';

/**
 * Logs the user out and sends them back to the login page when the API answers 401 on an
 * authenticated request (JWT expired). The login page reads the flag to explain why.
 */
const useSessionExpiredLogout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(
    () =>
      onSessionExpired(() => {
        logout();
        sessionStorage.setItem(SESSION_EXPIRED_KEY, 'true');
        navigate(ROUTE.LOGIN, { replace: true });
      }),
    [logout, navigate]
  );
};

export { useSessionExpiredLogout };
